document.addEventListener("click", function (e) {

  const img = e.target.closest(".js-zoom-image");
  if (!img) return;

  e.preventDefault();

  const src =
    img.getAttribute("data-zoom") ||
    img.getAttribute("src");

  console.log("ZOOM SRC:", src);

  if (!src) return;

  const modal = document.createElement("div");
  modal.className = "zoom-modal";

  const zoomImg = document.createElement("img");
  zoomImg.className = "zoom-modal-img";
  zoomImg.src = src;

  modal.appendChild(zoomImg);
  document.body.appendChild(modal);

  modal.addEventListener("click", () => modal.remove());

});